import { DEFAULT_LANG, SITE_URL, findSeoRoute } from "@/config/seoRoutes";
import { getLocalizedPath, UNLOCALIZED_ROUTES } from "@/lib/i18nRoutes";
import { normalizeSeoPath } from "@/lib/seo/normalizeSeoPath";

export function hreflangsFor({ path = "/", currentLang = DEFAULT_LANG } = {}) {
  const normalized = normalizeSeoPath(path);
  const cleanPath = normalized.path;
  const descriptor = findSeoRoute(cleanPath);
  const languages = descriptor?.localizedIn || [];
  if (!descriptor || languages.length <= 1) return [];
  if (normalized.routeKey && UNLOCALIZED_ROUTES[normalized.routeKey]) return [];

  const defaultLocalizedPath = normalized.routeKey ? getLocalizedPath(normalized.routeKey, DEFAULT_LANG) : null;
  const defaultCleanPath = defaultLocalizedPath
    ? (defaultLocalizedPath.replace(new RegExp(`^/${DEFAULT_LANG}(?=/|$)`), "") || "/").replace(/\/+$/, "") || "/"
    : null;
  const isTopLevelLocalizedRoute = normalized.routeKey && cleanPath === defaultCleanPath;

  const hrefFor = (lang) => descriptor.kind !== "dynamic" && isTopLevelLocalizedRoute
    ? `${SITE_URL}${getLocalizedPath(normalized.routeKey, lang)}`
    : `${SITE_URL}/${lang}${cleanPath === "/" ? "/" : cleanPath}`;

  const links = languages.map((lang) => ({ lang, href: hrefFor(lang) }));
  if (cleanPath === "/" && normalized.routeKey === "home") {
    links.push({ lang: "x-default", href: `${SITE_URL}/${DEFAULT_LANG}` });
    return links;
  }
  const defaultLang = languages.includes(DEFAULT_LANG) ? DEFAULT_LANG : languages[0] || DEFAULT_LANG;
  links.push({ lang: "x-default", href: hrefFor(defaultLang) });
  return links;
}